import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { clearFilter } from '../../../services/filter/actions';

import DirectoryPage from './DirectoryPage';
import HeadComponent from '../../HeadComponent';
import Breadcrumb from '../../breadcrumb/Breadcrumb';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';

export class MostPopularDirectoryPage extends React.Component {
    render() {
        const { match, isCodePromo = false, i18nPage } = this.props;
        const isOffline = match.params.type === PATH.OFFLINE;
        const isEbon = match.params.type === PATH.EBON;

        let title = i18nPage.ONLINE_TITLE;
        if (isCodePromo) {
            title = i18nPage.REDUCTION_TITLE;
        } else if (isOffline) {
            title = i18nPage.OFFLINE_TITLE;
        } else if (isEbon) {
            title = i18nPage.EBON_TITLE;
        }

        const canonicalLink = isCodePromo
            ? `${CONTEXT_ROOT}${PATH.REDUCTION_MOST_POPULAR_PATH}`
            : `${CONTEXT_ROOT}${PATH.CASHBACK_PATH}/${match.params.type}/${PATH.MOST_POPULAR_PATH}`;

        return (
            <div>
                <HeadComponent
                    title={title}
                    description={i18nPage.DESCRIPTION}
                    canonicalLink={canonicalLink}
                />
                <Breadcrumb
                    defaultRoute
                    routes={[
                        {
                            label: title,
                            route: match.url
                        }
                    ]}
                    cssClass="conteneur"
                />
                <DirectoryPage
                    letter={match.params.letter || ''}
                    isCodePromo={isCodePromo}
                    isOffline={isOffline}
                    isEbon={isEbon}
                />
            </div>
        );
    }
}

MostPopularDirectoryPage.propTypes = {
    isCodePromo: PropTypes.bool,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        i18nPage: state.i18n.page.DIRECTORY.MOST_POPULAR
    };
};

const mapDispatchToProps = {
    clearFilter
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(MostPopularDirectoryPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/directory/MostPopularDirectoryPage.js